import React from 'react';
import { Button } from '@/components/ui/button';

// Fix 6F F4: a load that failed with nothing on screen yet (PC1, PC3, PC7,
// PC10). The web has no pull gesture, so it shows the title and a "Try again"
// button that retries (reviewer addendum A1); a failed refresh while data is
// already on screen never renders this.
export default function LoadFailed({ title, onRetry, testIdPrefix, className = '' }) {
  return (
    <div className={className} role="alert" data-testid={`${testIdPrefix}-load-failed`}>
      <p className="text-sm font-semibold text-slate-800 dark:text-slate-100" data-testid={`${testIdPrefix}-load-failed-title`}>{title}</p>
      <Button variant="outline" size="sm" className="mt-3" onClick={onRetry} data-testid={`${testIdPrefix}-retry`}>
        Try again
      </Button>
    </div>
  );
}
